import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModaleLogoutComponent } from '../../../shared/components/modali/modale-logout/modale-logout.component';

import { HeaderComponent } from '../shared/components/header/header.component';
import { CommonModule } from '@angular/common';
import { Capacitor } from '@capacitor/core';

@Component({
	selector: 'app-profilo',
	standalone: true,
	imports: [CommonModule, HeaderComponent],
	templateUrl: './profilo.component.html',
})
export class ProfiloComponent {
	router = inject(Router);
	authService = inject(AuthService);
	modalService = inject(NgbModal);

	isNative = Capacitor.isNativePlatform();

	get fullName(): string {
		const u = this.authService.currentUser;
		return u ? `${u.nome} ${u.cognome}` : '';
	}

	get email(): string {
		return this.authService.currentUser?.user ?? '';
	}

	navigate(subPath: string) {
		this.router.navigate([`/app/dashboard/profilo/${subPath}`]);
	}

	confirmLogout() {
		const modalRef = this.modalService.open(ModaleLogoutComponent, { centered: true, windowClass: 'modal-app-custom' });
		modalRef.result.then(
			(result) => {
				if (result) {
					this.authService.logout();
				}
			},
			() => {},
		);
	}
}
